import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../../utils/apiPath';
import { agent } from '../../utils/agent';

export const getExperienceLevels = createAsyncThunk(
  'user/getExperienceLevels',
  async (userType, { rejectWithValue }) => {
    try {
      const response = await agent.get(`${API.EXPERIENCE}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchUserInfo = createAsyncThunk(
  'user/fetchUserInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await agent.get(API.GETUSERDATA); // Replace with your actual endpoint
      return response.data.data; // Ensure this is the user object
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: {
      id: null,
      full_name: "",
      email: ""
    },
    userExperience: [],
    loading: false,
    error: null,
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getExperienceLevels.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExperienceLevels.fulfilled, (state, action) => {
        state.loading = false;
        state.userExperience = action.payload;
      })
      .addCase(getExperienceLevels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUserInfo } = userSlice.actions;
export default userSlice.reducer;